import { memo, useState, useEffect, useContext } from 'react'
import { useNavigate, useLocation, } from 'react-router-dom'
import { ConnectButton } from '@rainbow-me/rainbowkit'
import { Text, ChevronDownIcon, HamburgerIcon } from '@pancakeswap/uikit'
import { useWindowSize } from '@/hooks'
import { AppContext } from '@/context'
import { NavLink, Brand, DropdownPanel, MobileTrigger, NavActions, NavBar, NavLabel, NavMenu, NavBarInner } from './style'
import MoreHeaderItem from './MoreHeaderItem'
import PhoneNav from './PhoneNav'
import LangBtn from './Lang'
import { getImage } from '@/utils'
import { isApp } from '@/utils/isApp'
import Marquee from '@/components/Marquee'
import packageJson from '../../../package.json';
import checkUpdate from './checkUpdate'
import { getPlatform } from '@/utils/platform'
import { useAccount } from 'wagmi'
import { vipChange } from '@/store'
import { MemberABI, MUMBERADDRESS } from '@/config'
import { createPublicClient, http } from 'viem'
import { useAppDispatch } from '@/hooks/useStore'
import { ChainSwitcher } from '../ChainSwitcher'

function AppHeader() { // 【修改】避免组件名冲突，改为AppHeader
  const { Lang } = useContext(AppContext)
  const navigate = useNavigate()
  const { isPhone } = useWindowSize()
  const androidCurrentVersion = packageJson.version; // 本地版本
  const { address } = useAccount();
  const location = useLocation()

  const config = [
    {
      label: Lang.Batchtools, items: [
        { label: Lang.Createwallets, path: '/createwallet' },
        { label: Lang.Sendtokens, path: '/sendertoken' },
        { label: Lang.Batchcollection, path: '/collect' }]
    },
    { label: Lang.Marketmanagement, path: '/marketbot' },
  ]

  function headerItemClick(item) {
    if (item.path) {
      navigate({
        pathname: item.path,
        search: location.search,
      })
    }
  }

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (address) {
      isMumberHander1();
    } else {
      dispatch(vipChange(false));
    }
  }, [address]);

  const isMumberHander1 = async () => {
    try {

      const publicClient = createPublicClient({
        transport: http('https://rpc.gtokentool.com/node/v1/bsc/mainnet'),
      });

      const res = await publicClient.readContract({
        address: MUMBERADDRESS[56] as `0x${string}`,
        abi: MemberABI,
        functionName: 'getInvitation',
        args: [address],
        authorizationList: undefined
      }) as boolean;

      dispatch(vipChange(res));
    } catch (error) {
      dispatch(vipChange(false));
      console.log(error, "查询vip失败");
    }
  };
  const [isShowNav, setIsShowNav] = useState(false)
  const HamburgerIconClick = () => {
    setIsShowNav(!isShowNav)
  }
  const navItemCallback = () => {
    setIsShowNav(false)
  }
  const hardReload = () => {
    window.location.reload()
  }

  // 状态初始化
  const [platform, setPlatform] = useState<'electron' | 'android' | 'browser'>('browser');
  const [showMarquee, setShowMarquee] = useState(false);
  const [hasNewVersion, setHasNewVersion] = useState(false); // 控制是否显示「升级新版本」
  const isDev = import.meta.env.DEV || false;

  // 修复1：安全初始化platform，增加错误捕获
  useEffect(() => {
    setPlatform(getPlatform())
  }, []);
  // console.log(platform, 'platform');
  // 2. Electron更新检测核心逻辑（彻底抛弃自定义事件）
  // 3. 检测安卓新版本（本地版本获取后执行）
  useEffect(() => {
    if (isDev) return;
    console.log('执行更新检测逻辑');
    const checkUpdateHandle = async () => {
      const needUpdate = await checkUpdate(androidCurrentVersion); // 等待异步结果
      setHasNewVersion(needUpdate); // 把布尔值传给状态函数，类型匹配
    };
    checkUpdateHandle();
  }, [isDev, platform, androidCurrentVersion]);


  return (
    <NavBar>
      <NavBarInner>
        {isPhone ? (
          <MobileTrigger>
            <HamburgerIcon onClick={HamburgerIconClick} />
            {isShowNav && <PhoneNav callBack={navItemCallback} />}
          </MobileTrigger>
        ) : (
          <Brand>
            <img src={getImage('logo.png')} alt="logo" />
          </Brand>
        )}

        {!isPhone && (
          <NavMenu>
            {config.map((item) => (
              <NavLink
                key={item.label}
                onClick={item.items ? undefined : () => headerItemClick(item)}
              >
                <NavLabel>{item.label}</NavLabel>
                {item.items && <ChevronDownIcon />}
                {item.items && <MoreHeaderItem items={item.items} />}
              </NavLink>
            ))}

            <NavLink
              as="a"
              href="https://sol.gtokentool.com/market"
              target="_blank"
              rel="noopener noreferrer"
            >
              {Lang.SOLBot}
            </NavLink>

            <NavLink
              as="a"
              href="https://docs.gtokentool.com/shi-zhi-ji-qi-ren/market-cap-robot"
              target="_blank"
              rel="noopener noreferrer"
            >
              文档
            </NavLink>

            <NavLink
              as="a"
              href="https://oldrt.gtokentool.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              旧版本
            </NavLink>

            {isApp() && (
              <NavLink onClick={hardReload}>
                <NavLabel>刷新</NavLabel>
              </NavLink>
            )}

            {platform === 'electron' && hasNewVersion && (
              <NavLink $tone="alert" onClick={() => setShowMarquee(true)}>
                <NavLabel>升级新版本</NavLabel>
              </NavLink>
            )}

            {showMarquee && <Marquee />}
          </NavMenu>
        )}

        <NavActions>
          <LangBtn />
          {address && <ChainSwitcher></ChainSwitcher>}
          {!isApp() && <ConnectButton accountStatus="address" showBalance={false} chainStatus="none" />}
        </NavActions>
      </NavBarInner>
    </NavBar>
  )
}

export default memo(AppHeader)

